var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDocument(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88 2H16.12C17.16 2 18 2.84 18 3.88V16.12C18 17.16 17.16 18 16.12 18H3.88C2.84 18 2 17.16 2 16.12V12.88C2 11.84 2.84 11 3.88 11H5V3.88C5 2.84 5.84 2 6.88 2ZM3.5 16.12C3.5 16.33 3.67 16.5 3.88 16.5H5.04C5.01 16.38 5 16.25 5 16.12V12.5H3.88C3.67 12.5 3.5 12.67 3.5 12.88V16.12ZM16.12 16.5C16.33 16.5 16.5 16.33 16.5 16.12V3.88C16.5 3.67 16.33 3.5 16.12 3.5H6.88C6.67 3.5 6.5 3.67 6.5 3.88V16.12C6.5 16.33 6.67 16.5 6.88 16.5H16.12ZM8.74821 6C8.33529 6 8.00055 6.33474 8.00055 6.74766C8.00055 7.16059 8.33529 7.49533 8.74821 7.49533H12.2859C12.6989 7.49533 13.0336 7.16059 13.0336 6.74766C13.0336 6.33474 12.6989 6 12.2859 6H8.74821ZM8.74766 9.6613C8.33474 9.6613 8 9.99604 8 10.409C8 10.8219 8.33474 11.1566 8.74766 11.1566H14.2854C14.6983 11.1566 15.0331 10.8219 15.0331 10.409C15.0331 9.99604 14.6983 9.6613 14.2854 9.6613H8.74766Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.28c4b1fb.svg";
export { ForwardRef as ReactComponent };